import React from "react";
import { Box, Button, Modal } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import "./RemoveEmployeesConfirmModal.css";

const modalStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 440,
  maxWidth: "calc(100vw - 32px)",
  bgcolor: "background.paper",
  borderRadius: "12px",
  boxShadow: 24,
  p: "28px 32px 24px",
  outline: "none",
  textAlign: "center",
};

export const RemoveEmployeesConfirmModal = ({
  open,
  onClose,
  onConfirm,
  confirming = false,
  removeCount = 0,
}) => {
  return (
    <Modal
      open={open}
      onClose={confirming ? undefined : onClose}
      aria-labelledby="remove-employees-title"
    >
      <Box sx={modalStyle} className="remove-employees-modal">
        <button
          type="button"
          className="remove-employees-modal__close"
          onClick={onClose}
          disabled={confirming}
          aria-label="Close"
        >
          <CloseIcon sx={{ fontSize: 18 }} />
        </button>

        <h2 id="remove-employees-title">Remove Selected Employees?</h2>
        <p className="remove-employees-modal__body">
          Are you sure you want to remove the selected employee
          {removeCount === 1 ? "" : "s"} from this event? Once removed,{" "}
          <span className="remove-employees-modal__highlight">
            their statuses will revert to eligible.
          </span>
        </p>

        <div className="remove-employees-modal__actions">
          <Button
            type="button"
            variant="outlined"
            className="remove-employees-modal__btn-cancel"
            onClick={onClose}
            disabled={confirming}
          >
            Cancel
          </Button>
          <Button
            type="button"
            variant="contained"
            className="remove-employees-modal__btn-confirm"
            disableElevation
            onClick={onConfirm}
            disabled={confirming}
          >
            {confirming ? "Removing…" : "Remove Employees"}
          </Button>
        </div>
      </Box>
    </Modal>
  );
};
